import { clsx } from "clsx";
import {
  DEFAULT_TONE,
  TONE_CLASSES,
  VARIANT_SIZE_CLASS,
  type TypographyBaseProps,
} from "./types";

export function buildTypographyClasses({
  variant,
  tone,
  className,
}: Pick<TypographyBaseProps, "variant" | "tone" | "className">) {
  const resolvedTone = tone ?? DEFAULT_TONE[variant];
  return clsx(VARIANT_SIZE_CLASS[variant], TONE_CLASSES[resolvedTone], className);
}
